import DownForMaintenance from '../../../components/Public/DownForMaintenance';
import Home from '../../../components/Dashboard/Home';
import i18next from 'i18next';
import NotFound from '../../../components/Public/NotFound';
import Documentation from '../../../Documentation';

export const SERVICE_ROUTES = {
  downForMaintenance: {
    path: '/down-for-maintenance',
    exact: true,
    additional: {
      component: DownForMaintenance,
      protected: false,
    },
  },
  root: {
    path: '/',
    exact: true,
    additional: {
      component: Home,
      title: i18next.t('titles:dashboard'),
      protected: true,
    },
  },
  documentation: {
    path: '/docs',
    exact: true,
    skipDashboardCommonLayout: true,
    additional: {
      component: Documentation,
      protected: true,
    },
  },
  notFound: {
    path: '/not-found',
    exact: true,
    additional: {
      component: NotFound,
      protected: true,
      title: i18next.t('titles:notFound'),
    },
  },
};


